import React from 'react';
function Eye({ size, stroke = 'currentColor', strokeWidth, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      {...otherProps}
    >
      <path
        d="M2.26805 12.741C2.12971 12.5169 2.06054 12.4049 2.02181 12.2321C1.99273 12.1024 1.99273 11.8977 2.02181 11.7679C2.06054 11.5951 2.12971 11.4831 2.26805 11.2591C3.41127 9.40765 6.81418 4.72729 12 4.72729C17.1858 4.72729 20.5887 9.40765 21.732 11.2591C21.8703 11.4831 21.9395 11.5951 21.9782 11.7679C22.0073 11.8977 22.0073 12.1024 21.9782 12.2321C21.9395 12.4049 21.8703 12.5169 21.732 12.741C20.5887 14.5924 17.1858 19.2727 12 19.2727C6.81418 19.2727 3.41127 14.5924 2.26805 12.741Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 15.1169C13.6831 15.1169 15.0475 13.7214 15.0475 12C15.0475 10.2786 13.6831 8.88314 12 8.88314C10.3169 8.88314 8.95251 10.2786 8.95251 12C8.95251 13.7214 10.3169 15.1169 12 15.1169Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Eye;
